import React, { useEffect, useState } from 'react'
import { get_faqs_data } from '../../api/Global';

const Faqs = () => {
      const [get_faqs, set_Get_Faqs] = useState([]);
    
          useEffect(() => {
                const handle_get_faqs_list = async () => {
                      try {
                            const response = await get_faqs_data();
                            set_Get_Faqs(response?.data?.data?.faqs)
                      }
                      catch (error) {
                            console.log("error", error)
                      }
                }
                handle_get_faqs_list();
          }, [])
    return (
        <div>
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-center mb-16">
                    <h2 className="text-3xl font-bold tracking-tight sm:text-4xl"><span className="sm:inline md:inline">FAQ's</span></h2>
                    <p className="text-gray-400 pt-3">FAQs About Locknpay's Domain</p>
                </div>
                <div className="transition-transform duration-500 ease-out">
                    <div className="w-full mx-auto sm:w-10/12 md:w-2/1">
                        <div className="mt-2 divide-y divide-slate-100">
                            {
                                get_faqs?.map((get_faqs_result) => {
                                    return (
                                        <>
                                            <details className="group rounded-2xl bg-white border-1 border-blue-400/30 p-3 mt-3">
                                                <summary className="flex w-full cursor-pointer justify-between text-left text-base/7 font-semibold text-slate-900 select-none group-open:text-indigo-600">
                                                    {get_faqs_result?.question}
                                                    <svg className="mt-0.5 ml-4 size-6 flex-none stroke-slate-700 group-open:stroke-indigo-500" fill="none" xmlns="http://www.w3.org/2000/svg" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                                                        <path d="M18 12H6" />
                                                        <path className="group-open:hidden" d="M12 6v12" />
                                                    </svg></summary>
                                                <div className="prose prose-slate prose-a:font-semibold prose-a:text-indigo-600 prose-a:hover:text-indigo-500 max-w-none bg-white p-3 text-gray-500">
                                                    <p>{get_faqs_result?.answer}</p>
                                                </div>
                                            </details>
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Faqs
